export default __webpack_public_path__ + "static/media/ecommerceWoocommerce.a82f54d2.png";